import DefaultLayout from "@component/Layout/Default"
import { HeaderAntBreadCrumb } from "@component/Layout/HeaderAntBreadCrumb"
import { HOME_BREADCRUMB, PAGINATION } from "@config/constant"
import { useAppDispatch } from "@hook/useAppDispatch"
import { changePageTitleAction } from "@reducer/common.reducer"
import { callVendorDetail } from "@reducer/version2/vendor-detail.reducer"
import { callGetUsers } from "@reducer/version2/user.reducer"
import { trans } from "@resources/localization"
import React, { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"
import { FormAddUser } from "./FormAddUser"
import { InfoVendor } from "./InfoVendor"
import { ListUser } from "./ListUser"
import { AccessDenied } from "@component/AccessDenied"
import { Notfound } from "@component/Notfound"

export const User: React.FC = () => {
    const dispatch = useAppDispatch()
    const [searchParams] = useSearchParams()
    const [statusShow, setStatusShow] = useState<number>(0)

    useEffect(() => {
        dispatch(changePageTitleAction(trans("sidebar.detail_vendor")))
        dispatch(callVendorDetail()).then((result: any) => {
            setStatusShow(result?.payload?.response?.status)
        })
    }, [dispatch])

    useEffect(() => {
        dispatch(
            callGetUsers({
                ...Object.fromEntries(searchParams.entries()),
                size: searchParams.has("size") ? Number(searchParams.get("size")) : PAGINATION.DEFAULT_PAGE_SIZE,
            })
        ).then((result: any) => {
            setStatusShow(result?.payload?.response?.status)
        })
    }, [dispatch, searchParams])
    return (
        <DefaultLayout loading={false}>
            {statusShow === 403 && <AccessDenied />}
            {statusShow === 404 && <Notfound />}
            {![403, 404].includes(statusShow) && (
                <>
                    <HeaderAntBreadCrumb breadCrumbs={[...HOME_BREADCRUMB, { name: "sidebar.detail_vendor", link: "/user" }]} />
                    <InfoVendor />
                    <ListUser />
                    <FormAddUser />
                </>
            )}
        </DefaultLayout>
    )
}
